function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#B8C8CC",
  fillRule: "evenodd",
  d: "M48.375 23.544C46.675 14.38 39.1 7.5 30 7.5c-7.225 0-13.5 4.356-16.625 10.731C5.85 19.081 0 25.855 0 34.062 0 42.855 6.725 50 15 50h32.5C54.4 50 60 44.05 60 36.719c0-7.013-5.125-12.697-11.625-13.175zm-20.192-2.882c1.05-.883 2.593-.883 3.644 0l.18.165 1.197 1.192-.01.007 1.34 1.34 4.805 4.79c.881.877.881 2.314 0 3.192-.88.878-2.322.878-3.203 0l-3.872-3.858.001 12.752c0 1.173-.909 2.144-2.06 2.249L30 42.5c-1.177 0-2.151-.906-2.256-2.053l-.01-.205V27.491l-3.87 3.857c-.829.826-2.155.875-3.042.146l-.161-.146c-.83-.826-.878-2.148-.147-3.032l.147-.16 4.805-4.79L26.8 22.03l-.003-.001 1.199-1.195.188-.171z"
});

var SvgUploadCloud = function SvgUploadCloud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUploadCloud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload-cloud.a03a2aa6.svg";
export { ForwardRef as ReactComponent };